import DropdownOption from "@/entities/DropdownOption";

type GetMultiselectValues = (values: string[]) => DropdownOption[];

const getMultiselectValues: GetMultiselectValues = (values: string[]): {id: string, name: string}[] => {
  return values.map(value => ({
    id: value,
    name: value,
  }));
}

export default getMultiselectValues;